import { render, staticRenderFns } from "./deposit-balance.vue?vue&type=template&id=05d6602a&"
import script from "./deposit-balance.vue?vue&type=script&lang=js&"
export * from "./deposit-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports